export const environment = {
  production: false,
  apiBaseURL: 'https://feature-api.emma.knustconnect.de'
};
